import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

const HOURS = Array.from({ length: 24 }, (_, i) => String(i).padStart(2, '0'));
const MINUTES = Array.from({ length: 60 }, (_, i) => String(i).padStart(2, '0'));

function parse(value) {
  const [h = '00', m = '00'] = String(value || '00:00').split(':');
  return [h.padStart(2, '0').slice(0, 2), m.padStart(2, '0').slice(0, 2)];
}

// Custom time picker (dropdowns) — avoids the native OS <input type="time"> picker
// whose Set/OK button can be clipped on mobile. Value format: "HH:MM".
export function TimeField({ icon: Icon, label, value, onChange, testid }) {
  const [h, m] = parse(value);
  return (
    <div>
      <div className="flex items-center gap-1.5 mb-1.5">
        {Icon ? <Icon className="w-4 h-4 text-muted-foreground" /> : null}
        <span className="text-xs text-muted-foreground">{label}</span>
      </div>
      <div className="flex items-center gap-2" data-testid={testid}>
        <Select value={h} onValueChange={(nh) => onChange(`${nh}:${m}`)}>
          <SelectTrigger data-testid={`${testid}-hour`} className="bg-[var(--c-film)] border-[var(--c-hair)] rounded-xl font-mono text-lg h-12">
            <SelectValue />
          </SelectTrigger>
          <SelectContent className="max-h-60">
            {HOURS.map(x => <SelectItem key={x} value={x} className="font-mono">{x}</SelectItem>)}
          </SelectContent>
        </Select>
        <span className="font-mono text-lg text-muted-foreground">:</span>
        <Select value={m} onValueChange={(nm) => onChange(`${h}:${nm}`)}>
          <SelectTrigger data-testid={`${testid}-min`} className="bg-[var(--c-film)] border-[var(--c-hair)] rounded-xl font-mono text-lg h-12">
            <SelectValue />
          </SelectTrigger>
          <SelectContent className="max-h-60">
            {MINUTES.map(x => <SelectItem key={x} value={x} className="font-mono">{x}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
}
